export default __webpack_public_path__ + "static/media/mortarboard.eddc55a0.svg";